module.exports = __webpack_public_path__ + "img/ktreco.6d9fccae.jpg";